// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testimonial-wrapper {
    padding-bottom: 15px;
    border-bottom: 1px dotted var(--disbaled-color);
}

.testimonial-wrapper>div:first-child img {
    cursor: pointer;
    padding-left: 10px;
}

.t-head {
    border-bottom: 1px solid var(--placeholder-color3);
}

.t-head>p {
    
    font-size: 14px;
    color: var(--placeholder-grey);
}
.down-image-absolute{
    right: 6px;
    width: 16px;
    top: 18px;
    width: 14px;
    position: absolute;
    transform: rotate(180deg);
}
.t-head>p:nth-child(2) {
    text-align: right;
}
.subCategoryContainer{
    display: block;
}

 .subCategoryContainer{
    margin-bottom: 17px;
 }
.t-body p:nth-child(2){
    margin: 0px 62px !important;
}
.t-body>p {
    font-family: var(--Inter-SemiBold600);
    font-size: 14px;
    line-height: 24px;
    color: var(--dark-purple);
   
}

.custom-box-style {
    min-height: 903px;
    /* height: 'auto'; */
    /* max-height: 903 !important; */
    /* height: 903 !important; */
    flex-grow: 1;
    position: 'relative';
    margin-bottom: 0px !important
}

.video-wrapper {
    margin-bottom: 27px;
}

.video-wrapper .video-wrapper-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding: 20px;
    border-bottom: 1px solid var(--placeholder-color3);
}

.video-wrapper .video-wrapper-container .thumbnail-wrapper {
    margin-right: 20px;
}

.video-wrapper .video-wrapper-container .thumbnail-wrapper img {
    width: 80px;
    height: 80px;
}

.video-wrapper-container .description-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.video-wrapper-container .description-wrapper>p:first-child {
    font-family: var(--Inter-SemiBold600);
    font-size: 16px;
    line-height: 24px;
    color: var(--dark-purple);
}

.video-wrapper-container .description-wrapper>p:nth-child(2)>span:nth-child(2) {
    font-family: var(--Inter-SemiBold600);
    font-size: 16px;
    line-height: 24px;
    color: var(--dark-purple);
}


.admin-content-data-container {
    overflow: auto;
    height: calc(903px - 86px);
    padding: 0px 18px;
}

.health-cate-data-container {
    overflow: auto;
    flex: 1 1;
    padding: 0px 18px;
}



/* media queries******************/

@media(max-width:1700px) {
    .manage-app-wrapper .user-info-subcontainer .second-box {
        margin-right: 0px;
    }

    .manage-app-wrapper .user-info-subcontainer .third-box {
        flex: none;
        width: 100% !important;
        margin-top: 25px;
    }
}

@media(max-width:1250px) {
    .manage-app-wrapper .user-info-subcontainer .first-box {
        margin-right: 0px;
    }

    .manage-app-wrapper .user-info-subcontainer .second-box {
        flex: none;
        width: 100%;
        margin-top: 25px;
    }
}

@media(max-width:800px) {
    .manage-app-wrapper .user-info-subcontainer .first-box {
        width: 100%;
        flex: none;
        margin-right: 0px;
    }

    .admin-content-data-container {
        height: calc(435px - 86px);
    }

    .manage-app-wrapper .user-info-subcontainer .first-box .custom-box-style {
        min-height: unset;
    }

    .client-detail-wrapper .item-wrapper .overlap-3 {
        margin-bottom: 0px;
        margin-left: 0px;
        width: 70% !important;
        word-break: break-all;
    }
}

@media(max-width:678px) {
    .text-wrapper-1 {
        line-height: 18px;
    }
}

@media(max-width:450px) {


    /* .manage-app-wrapper .user-info-subcontainer .client-detail-wrapper .item-wrappper {
        display: flex !important;
        flex-direction: column !important;
    } */

    .client-detail-wrapper .item-wrapper {
        flex-direction: column !important;
        justify-content: flex-start !important;
        width: 100% !important;
        align-items: flex-start !important;
    }

    .client-detail-wrapper .item-wrapper>p:first-child {
        margin-bottom: 5px !important;
        text-align: left !important;
    }

    .client-detail-wrapper .item-wrapper .overlap-3 {
        width: 100% !important;
    }

    .t-body>p,
    .t-head>p {
        margin: 0px !important;
    }

    .t-body>p:nth-child(2) {
        margin-right: 30px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/ManageApp.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,+CAA+C;AACnD;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;;IAEI,eAAe;IACf,8BAA8B;AAClC;AACA;IACI,UAAU;IACV,WAAW;IACX,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;;CAEC;IACG,mBAAmB;CACtB;AACD;IACI,2BAA2B;AAC/B;AACA;IACI,qCAAqC;IACrC,eAAe;IACf,iBAAiB;IACjB,yBAAyB;;AAE7B;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,gCAAgC;IAChC,4BAA4B;IAC5B,YAAY;IACZ,oBAAoB;IACpB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,kDAAkD;AACtD;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;;AAGA;IACI,cAAc;IACd,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,SAAO;IACP,iBAAiB;AACrB;;;;AAIA,kCAAkC;;AAElC;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,sBAAsB;QACtB,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,WAAW;QACX,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,UAAU;QACV,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,qBAAqB;QACrB,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;;;IAGI;;;OAGG;;IAEH;QACI,iCAAiC;QACjC,sCAAsC;QACtC,sBAAsB;QACtB,kCAAkC;IACtC;;IAEA;QACI,6BAA6B;QAC7B,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,sBAAsB;IAC1B;;IAEA;QACI,6BAA6B;IACjC;AACJ","sourcesContent":[".testimonial-wrapper {\n    padding-bottom: 15px;\n    border-bottom: 1px dotted var(--disbaled-color);\n}\n\n.testimonial-wrapper>div:first-child img {\n    cursor: pointer;\n    padding-left: 10px;\n}\n\n.t-head {\n    border-bottom: 1px solid var(--placeholder-color3);\n}\n\n.t-head>p {\n    \n    font-size: 14px;\n    color: var(--placeholder-grey);\n}\n.down-image-absolute{\n    right: 6px;\n    width: 16px;\n    top: 18px;\n    width: 14px;\n    position: absolute;\n    transform: rotate(180deg);\n}\n.t-head>p:nth-child(2) {\n    text-align: right;\n}\n.subCategoryContainer{\n    display: block;\n}\n\n .subCategoryContainer{\n    margin-bottom: 17px;\n }\n.t-body p:nth-child(2){\n    margin: 0px 62px !important;\n}\n.t-body>p {\n    font-family: var(--Inter-SemiBold600);\n    font-size: 14px;\n    line-height: 24px;\n    color: var(--dark-purple);\n   \n}\n\n.custom-box-style {\n    min-height: 903px;\n    /* height: 'auto'; */\n    /* max-height: 903 !important; */\n    /* height: 903 !important; */\n    flex-grow: 1;\n    position: 'relative';\n    margin-bottom: 0px !important\n}\n\n.video-wrapper {\n    margin-bottom: 27px;\n}\n\n.video-wrapper .video-wrapper-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    padding: 20px;\n    border-bottom: 1px solid var(--placeholder-color3);\n}\n\n.video-wrapper .video-wrapper-container .thumbnail-wrapper {\n    margin-right: 20px;\n}\n\n.video-wrapper .video-wrapper-container .thumbnail-wrapper img {\n    width: 80px;\n    height: 80px;\n}\n\n.video-wrapper-container .description-wrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.video-wrapper-container .description-wrapper>p:first-child {\n    font-family: var(--Inter-SemiBold600);\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--dark-purple);\n}\n\n.video-wrapper-container .description-wrapper>p:nth-child(2)>span:nth-child(2) {\n    font-family: var(--Inter-SemiBold600);\n    font-size: 16px;\n    line-height: 24px;\n    color: var(--dark-purple);\n}\n\n\n.admin-content-data-container {\n    overflow: auto;\n    height: calc(903px - 86px);\n    padding: 0px 18px;\n}\n\n.health-cate-data-container {\n    overflow: auto;\n    flex: 1;\n    padding: 0px 18px;\n}\n\n\n\n/* media queries******************/\n\n@media(max-width:1700px) {\n    .manage-app-wrapper .user-info-subcontainer .second-box {\n        margin-right: 0px;\n    }\n\n    .manage-app-wrapper .user-info-subcontainer .third-box {\n        flex: none;\n        width: 100% !important;\n        margin-top: 25px;\n    }\n}\n\n@media(max-width:1250px) {\n    .manage-app-wrapper .user-info-subcontainer .first-box {\n        margin-right: 0px;\n    }\n\n    .manage-app-wrapper .user-info-subcontainer .second-box {\n        flex: none;\n        width: 100%;\n        margin-top: 25px;\n    }\n}\n\n@media(max-width:800px) {\n    .manage-app-wrapper .user-info-subcontainer .first-box {\n        width: 100%;\n        flex: none;\n        margin-right: 0px;\n    }\n\n    .admin-content-data-container {\n        height: calc(435px - 86px);\n    }\n\n    .manage-app-wrapper .user-info-subcontainer .first-box .custom-box-style {\n        min-height: unset;\n    }\n\n    .client-detail-wrapper .item-wrapper .overlap-3 {\n        margin-bottom: 0px;\n        margin-left: 0px;\n        width: 70% !important;\n        word-break: break-all;\n    }\n}\n\n@media(max-width:678px) {\n    .text-wrapper-1 {\n        line-height: 18px;\n    }\n}\n\n@media(max-width:450px) {\n\n\n    /* .manage-app-wrapper .user-info-subcontainer .client-detail-wrapper .item-wrappper {\n        display: flex !important;\n        flex-direction: column !important;\n    } */\n\n    .client-detail-wrapper .item-wrapper {\n        flex-direction: column !important;\n        justify-content: flex-start !important;\n        width: 100% !important;\n        align-items: flex-start !important;\n    }\n\n    .client-detail-wrapper .item-wrapper>p:first-child {\n        margin-bottom: 5px !important;\n        text-align: left !important;\n    }\n\n    .client-detail-wrapper .item-wrapper .overlap-3 {\n        width: 100% !important;\n    }\n\n    .t-body>p,\n    .t-head>p {\n        margin: 0px !important;\n    }\n\n    .t-body>p:nth-child(2) {\n        margin-right: 30px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
